import { render, staticRenderFns } from "./LongComic.vue?vue&type=template&id=4669c738"
import script from "./LongComic.vue?vue&type=script&lang=js"
export * from "./LongComic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports